/**
 * Ana sayfa içeriği — tek yerde.
 *
 * Metinlerin tamamı mevcut `src/LandingPage.tsx`'ten alındı; uydurma içerik yok.
 * Emoji yerine lucide ikonları kullanılıyor: ekranda emoji her işletim sisteminde
 * farklı çizilir ve iş yazılımından çok sohbet penceresi hissi verir.
 */
import {
  Users, Wrench, ClipboardList, Package, Wallet, Receipt,
  UserCog, MessageSquare, Smartphone, FileText, Bell, BarChart3,
  type LucideIcon,
} from 'lucide-react';

export interface Ozellik {
  ikon: LucideIcon;
  baslik: string;
  aciklama: string;
}

export const OZELLIKLER: Ozellik[] = [
  {
    ikon: Users,
    baslik: 'Müşteri Yönetimi',
    aciklama: 'Kapsamlı müşteri veritabanı, müşteri listesi, borç/alacak takibi, müşteri geçmişi kayıtları.',
  },
  {
    ikon: Wrench,
    baslik: 'Teknik Servis Takibi',
    aciklama: 'Bekleyen servisler, teslim edilecek cihazlar, tamamlanan servisler. QR kod ile hızlı kayıt.',
  },
  {
    ikon: ClipboardList,
    baslik: 'İş Emirleri Yönetimi',
    aciklama: 'Yeni iş emri oluşturma, bekleyen iş emirleri takibi, tamamlanan iş emirleri raporlama.',
  },
  {
    ikon: Package,
    baslik: 'Stok Yönetimi',
    aciklama: 'Stok kayıtları, transfer fişi, depo yönetimi, seri numarası kontrolü. Kritik stok uyarıları.',
  },
  {
    ikon: Wallet,
    baslik: 'Kasa Yönetimi',
    aciklama: 'Masraf takibi, kasa ayarları, kasa durumu, nakit akış yönetimi.',
  },
  {
    ikon: Receipt,
    baslik: 'Fatura ve İşlem Takibi',
    aciklama: 'Satış ve alış fatura oluşturma, işlem listesi, borç/alacak dekontları.',
  },
  {
    ikon: UserCog,
    baslik: 'Personel Yönetimi',
    aciklama: 'Personel kayıtları, yetki yönetimi, maaş ödemeleri, avans ödemeleri, puantaj.',
  },
  {
    ikon: MessageSquare,
    baslik: 'SMS ve WhatsApp',
    aciklama: 'Otomatik bildirim gönderimi, müşteri bilgilendirme, gönderim takibi.',
  },
  {
    ikon: Smartphone,
    baslik: 'Mobil Erişim',
    aciklama: 'Her yerden erişim, bulut tabanlı çalışma, gerçek zamanlı senkronizasyon.',
  },
  {
    ikon: FileText,
    baslik: 'Teklif Oluşturma',
    aciklama: 'Profesyonel teklif hazırlama, PDF gönderimi, e-posta ile iletim, teklif durumu takibi.',
  },
  {
    ikon: Bell,
    baslik: 'Hatırlatma Sistemi',
    aciklama: 'Vade hatırlatmaları, otomatik bildirimler, öncelik seviyeli takip.',
  },
  {
    ikon: BarChart3,
    baslik: 'Kapsamlı Raporlama',
    aciklama: 'Günlük satış, kâr-zarar, stok, personel performans ve SMS raporları.',
  },
];

/** Hero altındaki sayılar — mevcut sayfadaki değerler korundu. */
export const RAKAMLAR = [
  { deger: '1000+', etiket: 'Aktif İşletme' },
  { deger: '50K+',  etiket: 'Takip Edilen Cihaz' },
  { deger: '%300', etiket: 'Verimlilik Artışı' },
];

/** Panel önizlemesindeki örnek satırlar — gerçek müşteri verisi DEĞİL, temsilîdir. */
export const ORNEK_SERVISLER = [
  { cihaz: 'iPhone 13 Pro',      islem: 'Ekran değişimi',  durum: 'Tamamlandı',   tur: 'olumlu' as const },
  { cihaz: 'Samsung Galaxy S21', islem: 'Şarj soketi',     durum: 'İşlemde',      tur: 'uyari'  as const },
  { cihaz: 'MacBook Air',        islem: 'Klavye değişimi', durum: 'Tamamlandı',   tur: 'olumlu' as const },
  { cihaz: 'Lenovo ThinkPad',    islem: 'Anakart onarımı', durum: 'Parça bekliyor', tur: 'uyari' as const },
];
